<template>
    <div>
        <error :name="'500'" :desc="'抱歉，服务器出错了'"></error>
    </div>
</template>

<script>
    import error from '@/components/error.vue';
    export default {
        components: {
            error
        }
    }
</script>
